import React from "react";

type TrendPyramidIconProps = {
  direction: "up" | "down";
  size?: number;
  className?: string;
};

const TrendPyramidIcon = ({ direction, size = 10, className = "" }: TrendPyramidIconProps) => {
  const isUp = direction === "up";

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 12"
      aria-hidden="true"
      className={className}
      style={{ display: "inline-block", verticalAlign: "middle" }}
    >
      {isUp ? (
        <>
          <polygon points="6,1 11,10 1,10" fill="currentColor" opacity="0.98" />
          <polygon points="6,1 8.8,6.6 6,6.6" fill="#ffffff" opacity="0.26" />
        </>
      ) : (
        <>
          <polygon points="1,2 11,2 6,11" fill="currentColor" opacity="0.98" />
          <polygon points="6,11 8.8,5.4 6,5.4" fill="#ffffff" opacity="0.26" />
        </>
      )}
    </svg>
  );
};

export default TrendPyramidIcon;
